import React from 'react'
import './AboutUs.css'

const AboutUs = () => {
  return (
    <div className='about-page'>

      <div className='about-hero'>
        <h1>Our Story</h1>
        <p>Born from a desire to bring joy back to the community, Tagers Shoppe is more than just a store — it's a mission to share experiences and joy.</p>
      </div>

      <div className='about-section'>
        <div className='about-section-text'>
          <h2>The Beginning</h2>
          <p>Our founder grew up in a family where community and your connection with those around you are the key to life's joys.</p>
          <p>Through play he learnt friendship, competition and comraderie.</p>
          <p>As he grew older the desire to share these things grew incredibly strong, as he saw the lack of such positive qualities present in those around him.</p>
        </div>
        <div className='about-section-visual'>
          <div className='about-placeholder'>
            &#127922;
            <span>Play &amp; Connection</span>
          </div>
        </div>
      </div>

      <div className='about-section'>
        <div className='about-section-text'>
          <h2>A Mission for Change</h2>
          <p>Tager's Shoppe was founded to bridge that gap. Every product we stock — from board games and trading card games — is chosen not just for quality, but for the experiences they enable. We believe that the simple act of gathering around a table or playing a game can strengthen the bonds that hold us all together.</p>
        </div>
        <div className='about-section-visual'>
          <div className='about-placeholder'>
            &#127758;
            <span>Community First</span>
          </div>
        </div>
      </div>

      <div className='about-section'>
        <div className='about-section-text'>
          <h2>Looking Forward</h2>
          <p>We are still small, but we dream big. Every customer who walks through our doors — physical or digital — becomes part of a movement to bring back joy to a world which seems so bereft of it. </p>
          <p>Whether you are here for a new board game or a rare card, you are helping us build a better community.</p>
          <p>Thank you for being part of our collective story.</p>
        </div>
        <div className='about-section-visual'>
          <div className='about-placeholder'>
            &#127775;
            <span>Building Together</span>
          </div>
        </div>
      </div>

      <div className='about-mission'>
        <h2>What We Stand For</h2>
        <div className='about-values'>
          <div className='about-value-card'>
            <h3>Community</h3>
            <p>We exist to serve and strengthen our local community, creating spaces for connection and play.</p>
          </div>
          <div className='about-value-card'>
            <h3>Accessibility</h3>
            <p>Everyone deserves access to joy and recreation, regardless of their circumstances.</p>
          </div>
          <div className='about-value-card'>
            <h3>Quality</h3>
            <p>We carefully curate products that bring lasting value and real experiences to your life.</p>
          </div>
        </div>
      </div>

    </div>
  )
}

export default AboutUs
